import React, {useState, useEffect, useRef} from 'react'
import styles from './UIGamePause.module.scss'
import {Button, T} from '@colonist/ui'
import {Timer} from '../../common/Timer/Timer.tsx'
import {useRequestResume} from '../../hooks/usePause.ts'
import {useGameStore} from '../../store/GameStoreContext.ts'

export const UIGamePause = () => {
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const remainingPauseTimeMS = useGameStore((state) => state.gamePause.remainingPauseTimeMS)
    const requestResume = useRequestResume()
    const [countdown, setCountdown] = useState<number | undefined>(undefined)
    const startTimeRef = useRef<number | undefined>(undefined)

    useEffect(() => {
        if(!isPaused) {
            setCountdown(undefined)
            startTimeRef.current = undefined
            return
        }

        if(remainingPauseTimeMS !== undefined) {
            startTimeRef.current = Date.now()
            setCountdown(Math.floor(remainingPauseTimeMS / 1000))
        }

        const timer = setInterval(() => {
            if(startTimeRef.current === undefined || remainingPauseTimeMS === undefined) return

            const elapsed = Date.now() - startTimeRef.current
            const remaining = Math.max(0, Math.floor((remainingPauseTimeMS - elapsed) / 1000))

            setCountdown(remaining)
            if(remaining <= 0) {
                clearInterval(timer)
            }
        }, 100) // Update more frequently for smoother countdown

        return () => clearInterval(timer)
    }, [isPaused, remainingPauseTimeMS])

    if(!isPaused) return null

    return <div className={styles.container}>
        <div className={styles.title}>
            <T id="strings:game.pause.paused"/>
        </div>
        <div className={styles.timer}>
            <Timer timeLeftInSeconds={countdown} />
        </div>
        <div className={styles.buttons}>
            <Button className={styles.resumeButton} onClick={requestResume}>
                <T id="strings:game.pause.resume"/>
            </Button>
        </div>
    </div>
}
